module.exports = __webpack_public_path__ + "img/NewCustomersSop.7362d1d9.png";